export { default } from "./useIsComponentVisible";
